export const iconFontAwesomeLogisticsCar = (
	<i className="fa-solid fa-car"></i>
);
